import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { PrimengLibraryModule } from 'primeng-library';

class LibViewClientInfoService {
    constructor(http) {
        this.http = http;
        this.onLoadResponseSubject = new BehaviorSubject(null);
    }
    getClientInfo(clientId) {
        return this.http.get(`/vd/fb/get/talentAcq/taClient/${clientId}`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
}
LibViewClientInfoService.ɵfac = function LibViewClientInfoService_Factory(t) { return new (t || LibViewClientInfoService)(i0.ɵɵinject(i1.HttpClient)); };
LibViewClientInfoService.ɵprov = i0.ɵɵdefineInjectable({ token: LibViewClientInfoService, factory: LibViewClientInfoService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibViewClientInfoService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function LibViewClientInfoComponent_div_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵelementStart(2, "p", 6);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 4);
    i0.ɵɵelementStart(5, "p", 6);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 4);
    i0.ɵɵelementStart(8, "p", 6);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const contact_r10 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (contact_r10 == null ? null : contact_r10.contactPerson) ? contact_r10 == null ? null : contact_r10.contactPerson : "--", " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (contact_r10 == null ? null : contact_r10.email) ? contact_r10 == null ? null : contact_r10.email : "--", " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (contact_r10 == null ? null : contact_r10.phoneNumber) ? contact_r10 == null ? null : contact_r10.phoneNumber : "--", " ");
} }
function LibViewClientInfoComponent_div_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "h5");
    i0.ɵɵtext(3, "Registered Address");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LibViewClientInfoComponent_div_37_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "p", 5);
    i0.ɵɵtext(3, " Address 1 ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p", 6);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 2);
    i0.ɵɵelementStart(7, "p", 5);
    i0.ɵɵtext(8, " Address 2 ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p", 6);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 13);
    i0.ɵɵelementStart(12, "p", 5);
    i0.ɵɵtext(13, " City ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "p", 6);
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 13);
    i0.ɵɵelementStart(17, "p", 5);
    i0.ɵɵtext(18, " Country ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "p", 6);
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 13);
    i0.ɵɵelementStart(22, "p", 5);
    i0.ɵɵtext(23, " State ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "p", 6);
    i0.ɵɵtext(25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "div", 13);
    i0.ɵɵelementStart(27, "p", 5);
    i0.ɵɵtext(28, " Zip / Postal Code ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "p", 6);
    i0.ɵɵtext(30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r2.registeredAddress == null ? null : ctx_r2.registeredAddress.addressLine1) ? ctx_r2.registeredAddress == null ? null : ctx_r2.registeredAddress.addressLine1 : "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r2.registeredAddress == null ? null : ctx_r2.registeredAddress.addressLine2) ? ctx_r2.registeredAddress == null ? null : ctx_r2.registeredAddress.addressLine2 : "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r2.registeredAddress == null ? null : ctx_r2.registeredAddress.city) ? ctx_r2.registeredAddress == null ? null : ctx_r2.registeredAddress.city : "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r2.registeredAddress == null ? null : ctx_r2.registeredAddress.countryName) ? ctx_r2.registeredAddress == null ? null : ctx_r2.registeredAddress.countryName : "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r2.registeredAddress == null ? null : ctx_r2.registeredAddress.stateName) ? ctx_r2.registeredAddress == null ? null : ctx_r2.registeredAddress.stateName : "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r2.registeredAddress == null ? null : ctx_r2.registeredAddress.postCode) ? ctx_r2.registeredAddress == null ? null : ctx_r2.registeredAddress.postCode : "--", " ");
} }
function LibViewClientInfoComponent_div_38_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "h5");
    i0.ɵɵtext(3, "Mailing Address");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LibViewClientInfoComponent_div_39_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "p", 5);
    i0.ɵɵtext(3, " Address 1 ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p", 6);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 2);
    i0.ɵɵelementStart(7, "p", 5);
    i0.ɵɵtext(8, " Address 2 ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p", 6);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 13);
    i0.ɵɵelementStart(12, "p", 5);
    i0.ɵɵtext(13, " City ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "p", 6);
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 13);
    i0.ɵɵelementStart(17, "p", 5);
    i0.ɵɵtext(18, " Country ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "p", 6);
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 13);
    i0.ɵɵelementStart(22, "p", 5);
    i0.ɵɵtext(23, " State ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "p", 6);
    i0.ɵɵtext(25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "div", 13);
    i0.ɵɵelementStart(27, "p", 5);
    i0.ɵɵtext(28, " Locality ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "p", 6);
    i0.ɵɵtext(30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(31, "div", 13);
    i0.ɵɵelementStart(32, "p", 5);
    i0.ɵɵtext(33, " Zip / Postal Code ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "p", 6);
    i0.ɵɵtext(35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r4.mailingAddress == null ? null : ctx_r4.mailingAddress.addressLine1) ? ctx_r4.mailingAddress == null ? null : ctx_r4.mailingAddress.addressLine1 : "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r4.mailingAddress == null ? null : ctx_r4.mailingAddress.addressLine2) ? ctx_r4.mailingAddress == null ? null : ctx_r4.mailingAddress.addressLine2 : "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r4.mailingAddress == null ? null : ctx_r4.mailingAddress.city) ? ctx_r4.mailingAddress == null ? null : ctx_r4.mailingAddress.city : "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r4.mailingAddress == null ? null : ctx_r4.mailingAddress.countryName) ? ctx_r4.mailingAddress == null ? null : ctx_r4.mailingAddress.countryName : "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r4.mailingAddress == null ? null : ctx_r4.mailingAddress.stateName) ? ctx_r4.mailingAddress == null ? null : ctx_r4.mailingAddress.stateName : "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r4.mailingAddress == null ? null : ctx_r4.mailingAddress.locality) ? ctx_r4.mailingAddress == null ? null : ctx_r4.mailingAddress.locality : "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r4.mailingAddress == null ? null : ctx_r4.mailingAddress.postCode) ? ctx_r4.mailingAddress == null ? null : ctx_r4.mailingAddress.postCode : "--", " ");
} }
function LibViewClientInfoComponent_div_40_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "h5");
    i0.ɵɵtext(3, "Billing Address");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LibViewClientInfoComponent_div_41_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "p", 5);
    i0.ɵɵtext(3, " Address 1 ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p", 6);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 2);
    i0.ɵɵelementStart(7, "p", 5);
    i0.ɵɵtext(8, " Address 2 ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p", 6);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 13);
    i0.ɵɵelementStart(12, "p", 5);
    i0.ɵɵtext(13, " City ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "p", 6);
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 13);
    i0.ɵɵelementStart(17, "p", 5);
    i0.ɵɵtext(18, " Country ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "p", 6);
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 13);
    i0.ɵɵelementStart(22, "p", 5);
    i0.ɵɵtext(23, " State ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "p", 6);
    i0.ɵɵtext(25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "div", 13);
    i0.ɵɵelementStart(27, "p", 5);
    i0.ɵɵtext(28, " Zip / Postal Code ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "p", 6);
    i0.ɵɵtext(30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r6.billingAddress == null ? null : ctx_r6.billingAddress.addressLine1) ? ctx_r6.billingAddress == null ? null : ctx_r6.billingAddress.addressLine1 : "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r6.billingAddress == null ? null : ctx_r6.billingAddress.addressLine2) ? ctx_r6.billingAddress == null ? null : ctx_r6.billingAddress.addressLine2 : "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r6.billingAddress == null ? null : ctx_r6.billingAddress.city) ? ctx_r6.billingAddress == null ? null : ctx_r6.billingAddress.city : "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r6.billingAddress == null ? null : ctx_r6.billingAddress.countryName) ? ctx_r6.billingAddress == null ? null : ctx_r6.billingAddress.countryName : "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r6.billingAddress == null ? null : ctx_r6.billingAddress.stateProvinceCode) ? ctx_r6.billingAddress == null ? null : ctx_r6.billingAddress.stateProvinceCode : "--", " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r6.billingAddress == null ? null : ctx_r6.billingAddress.postCode) ? ctx_r6.billingAddress == null ? null : ctx_r6.billingAddress.postCode : "--", " ");
} }
function LibViewClientInfoComponent_div_42_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "h5");
    i0.ɵɵtext(3, "Vendor Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LibViewClientInfoComponent_div_43_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵelementStart(2, "p", 5);
    i0.ɵɵtext(3, " Contact Person ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 4);
    i0.ɵɵelementStart(5, "p", 5);
    i0.ɵɵtext(6, " Email ID ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 4);
    i0.ɵɵelementStart(8, "p", 5);
    i0.ɵɵtext(9, " Contact Number ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 4);
    i0.ɵɵelementStart(11, "p", 5);
    i0.ɵɵtext(12, " Location ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LibViewClientInfoComponent_div_44_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "div", 4);
    i0.ɵɵelementStart(2, "p", 6);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 4);
    i0.ɵɵelementStart(5, "p", 6);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 4);
    i0.ɵɵelementStart(8, "p", 6);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 4);
    i0.ɵɵelementStart(11, "p", 6);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const contact_r11 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (contact_r11 == null ? null : contact_r11.contactPerson) ? contact_r11 == null ? null : contact_r11.contactPerson : "--", " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (contact_r11 == null ? null : contact_r11.email) ? contact_r11 == null ? null : contact_r11.email : "--", " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (contact_r11 == null ? null : contact_r11.phoneNumber) ? contact_r11 == null ? null : contact_r11.phoneNumber : "--", " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (contact_r11 == null ? null : contact_r11.location) ? contact_r11 == null ? null : contact_r11.location : "--", " ");
} }
class LibViewClientInfoComponent {
    constructor(clientInfoService) {
        this.clientInfoService = clientInfoService;
        this.observableSubscription$ = new Subject();
        this.mailingAddress = null;
        this.registeredAddress = null;
        this.billingAddress = null;
    }
    ngOnInit() {
        this.getClientInfo();
    }
    getLatestRowID() {
        const fbFormDataDTO = JSON.parse(sessionStorage.getItem('fbFormDataDTO'));
        return fbFormDataDTO[fbFormDataDTO.length - 1].id;
    }
    getClientInfo() {
        this.clientId = 'fbFormDataDTO' in sessionStorage ? this.getLatestRowID() : null;
        if (this.clientId) {
            this.clientInfoService.getClientInfo(this.clientId).pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
                var _a;
                this.clientDetails = response.data || null;
                if (this.clientDetails) {
                    sessionStorage.setItem("toClientEmail", JSON.stringify((_a = this.clientDetails) === null || _a === void 0 ? void 0 : _a.fbClientCompanyDetailsList));
                }
                if (this.clientDetails.addressList.length > 0) {
                    this.mailingAddress = this.clientDetails.addressList.find(item => item.addressTypeCode.includes("Mailing"));
                    this.registeredAddress = this.clientDetails.addressList.find(item => item.addressTypeCode.includes('Registered'));
                    this.billingAddress = this.clientDetails.addressList.find(item => item.addressTypeCode.includes("Billing Address"));
                }
            });
        }
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
LibViewClientInfoComponent.ɵfac = function LibViewClientInfoComponent_Factory(t) { return new (t || LibViewClientInfoComponent)(i0.ɵɵdirectiveInject(LibViewClientInfoService)); };
LibViewClientInfoComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LibViewClientInfoComponent, selectors: [["lib-view-client-info"]], decls: 51, vars: 14, consts: [[1, "container-fluid", "view_client_summary", "p-0", "m-0", "mt-2"], [1, "row"], [1, "col-6"], [1, "row", "bgHighlight"], [1, "col-3"], [1, "view_candidate_details_heading"], [1, "view_candidate_details_content"], [1, "row", "mt-4"], ["class", "row bgHighlight", 4, "ngFor", "ngForOf"], ["class", "row mt-4", 4, "ngIf"], ["class", "row bgHighlight", 4, "ngIf"], [1, "row", "bgHighlight", "mt-4"], [1, "col"], [1, "col-2"]], template: function LibViewClientInfoComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "h5");
        i0.ɵɵtext(4, "Client Company Details");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 3);
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵelementStart(7, "p", 5);
        i0.ɵɵtext(8, " Company / Organization name ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "p", 6);
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 4);
        i0.ɵɵelementStart(12, "p", 5);
        i0.ɵɵtext(13, " Business Type ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "p", 6);
        i0.ɵɵtext(15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 4);
        i0.ɵɵelementStart(17, "p", 5);
        i0.ɵɵtext(18, " Client Category ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "p", 6);
        i0.ɵɵtext(20);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "div", 7);
        i0.ɵɵelementStart(22, "div", 2);
        i0.ɵɵelementStart(23, "h5");
        i0.ɵɵtext(24, "Contact Details");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(25, "div", 3);
        i0.ɵɵelementStart(26, "div", 4);
        i0.ɵɵelementStart(27, "p", 5);
        i0.ɵɵtext(28, " Contact Person ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(29, "div", 4);
        i0.ɵɵelementStart(30, "p", 5);
        i0.ɵɵtext(31, " Email ID ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "div", 4);
        i0.ɵɵelementStart(33, "p", 5);
        i0.ɵɵtext(34, " Contact Number ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(35, LibViewClientInfoComponent_div_35_Template, 10, 3, "div", 8);
        i0.ɵɵtemplate(36, LibViewClientInfoComponent_div_36_Template, 4, 0, "div", 9);
        i0.ɵɵtemplate(37, LibViewClientInfoComponent_div_37_Template, 31, 6, "div", 10);
        i0.ɵɵtemplate(38, LibViewClientInfoComponent_div_38_Template, 4, 0, "div", 9);
        i0.ɵɵtemplate(39, LibViewClientInfoComponent_div_39_Template, 36, 7, "div", 10);
        i0.ɵɵtemplate(40, LibViewClientInfoComponent_div_40_Template, 4, 0, "div", 9);
        i0.ɵɵtemplate(41, LibViewClientInfoComponent_div_41_Template, 31, 6, "div", 10);
        i0.ɵɵtemplate(42, LibViewClientInfoComponent_div_42_Template, 4, 0, "div", 9);
        i0.ɵɵtemplate(43, LibViewClientInfoComponent_div_43_Template, 13, 0, "div", 10);
        i0.ɵɵtemplate(44, LibViewClientInfoComponent_div_44_Template, 13, 4, "div", 8);
        i0.ɵɵelementStart(45, "div", 11);
        i0.ɵɵelementStart(46, "div", 12);
        i0.ɵɵelementStart(47, "p", 6);
        i0.ɵɵtext(48, " Highlighted Note ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(49, "p", 5);
        i0.ɵɵtext(50);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(10);
        i0.ɵɵtextInterpolate1(" ", (ctx.clientDetails == null ? null : ctx.clientDetails.clientCompanyName) ? ctx.clientDetails == null ? null : ctx.clientDetails.clientCompanyName : "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", (ctx.clientDetails == null ? null : ctx.clientDetails.businessTypeId) ? ctx.clientDetails == null ? null : ctx.clientDetails.businessTypeId == null ? null : ctx.clientDetails.businessTypeId.name : "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", (ctx.clientDetails == null ? null : ctx.clientDetails.clientCategoryId) ? ctx.clientDetails == null ? null : ctx.clientDetails.clientCategoryId == null ? null : ctx.clientDetails.clientCategoryId.name : "--", " ");
        i0.ɵɵadvance(15);
        i0.ɵɵproperty("ngForOf", ctx.clientDetails == null ? null : ctx.clientDetails.fbClientCompanyDetailsList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.registeredAddress);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.registeredAddress);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.mailingAddress);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.mailingAddress);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.billingAddress);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.billingAddress);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.clientDetails == null ? null : ctx.clientDetails.fbClientVendorDetails) && ctx.clientDetails.fbClientVendorDetails.length > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.clientDetails == null ? null : ctx.clientDetails.fbClientVendorDetails) && ctx.clientDetails.fbClientVendorDetails.length > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.clientDetails == null ? null : ctx.clientDetails.fbClientVendorDetails);
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1(" ", (ctx.clientDetails == null ? null : ctx.clientDetails.highletedNotes) ? ctx.clientDetails == null ? null : ctx.clientDetails.highletedNotes : "--", " ");
    } }, directives: [i2.NgForOf, i2.NgIf], styles: [".view_client_summary[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#6d6d6d;font-weight:600}.view_client_summary[_ngcontent-%COMP%]   .view_candidate_details_heading[_ngcontent-%COMP%]{font-size:14px;margin-bottom:0}.view_client_summary[_ngcontent-%COMP%]   .view_candidate_details_content[_ngcontent-%COMP%]{font-weight:600}.view_client_summary[_ngcontent-%COMP%]   .pdf_section[_ngcontent-%COMP%]{border-top:2px dashed #ccc;padding-top:30px}.view_client_summary[_ngcontent-%COMP%]   .bgHighlight[_ngcontent-%COMP%]{background:#f7faff;padding-top:10px;padding-bottom:10px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibViewClientInfoComponent, [{
        type: Component,
        args: [{
                selector: 'lib-view-client-info',
                templateUrl: 'lib-view-client-info.component.html',
                styleUrls: ['lib-view-client-info.component.scss']
            }]
    }], function () { return [{ type: LibViewClientInfoService }]; }, null); })();

class LibViewClientInfoModule {
}
LibViewClientInfoModule.ɵfac = function LibViewClientInfoModule_Factory(t) { return new (t || LibViewClientInfoModule)(); };
LibViewClientInfoModule.ɵmod = i0.ɵɵdefineNgModule({ type: LibViewClientInfoModule });
LibViewClientInfoModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            BrowserModule,
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LibViewClientInfoModule, { declarations: [LibViewClientInfoComponent], imports: [CommonModule,
        BrowserModule,
        PrimengLibraryModule], exports: [LibViewClientInfoComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibViewClientInfoModule, [{
        type: NgModule,
        args: [{
                declarations: [LibViewClientInfoComponent],
                imports: [
                    CommonModule,
                    BrowserModule,
                    PrimengLibraryModule
                ],
                exports: [LibViewClientInfoComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of lib-view-client-info
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LibViewClientInfoComponent, LibViewClientInfoModule, LibViewClientInfoService };
//# sourceMappingURL=lib-view-client-info.js.map
